import { useIntl } from "react-intl";
import ErrorPage from "../ErrorPage/ErrorPage";

const AccessDenied = () => {
  const intl = useIntl();
  return (
    <ErrorPage
      type="accessDenied"
      title={intl.formatMessage({
        id: "Access Denied Page Title",
        defaultMessage: "Access Denied",
      })}
      description={intl.formatMessage({
        id: "Access Denied Page Description",
        defaultMessage:
          "We're sorry, it looks like you don’t have permission to view this page. For assistance, please click on 'Contact Us' to reach our support team.",
      })}
      imgUrl="/ui/images/Truman-UI-access-denied.svg"
    />
  );
};

export default AccessDenied;
